/**
 * Theme color-mode context (ported from dink-admin DNKADM-0266). `themeMode` is
 * the user's stated preference (light/dark/system); `resolvedMode` is the
 * concrete mode after resolving `system` against the OS `prefers-color-scheme`.
 */
import { createContext, useContext } from 'react';

export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemeModeContextValue {
  themeMode: ThemeMode;
  resolvedMode: 'light' | 'dark';
  setThemeMode: (mode: ThemeMode) => void;
}

export const ThemeModeContext = createContext<ThemeModeContextValue>({
  themeMode: 'system',
  resolvedMode: 'light',
  setThemeMode: () => {},
});

export function useThemeMode(): ThemeModeContextValue {
  return useContext(ThemeModeContext);
}
